import { Component, OnInit, Input, inject } from "@angular/core";

import { ApiService } from "src/app/api.service";
import { ChartingService } from "src/app/charting.service";
import { DvsUtilities } from "src/app/dvs-utilities";
import { DvsChartComponent } from "src/app/shared/dvs-chart/dvs-chart.component";
import { APIResults, AssemblyConfig } from "src/app/sharedinterfaces";

@Component({
	selector: "app-fleet-comparison",
	templateUrl: "./fleet-comparison.component.html",
	styleUrls: ["./fleet-comparison.component.scss"],
	imports: [DvsChartComponent]
})
export class FleetComparisonComponent implements OnInit {
	api = inject(ApiService);
	charting = inject(ChartingService);

	@Input()
	asset: APIResults.FleetAsset;
	@Input()
	fleet: APIResults.Fleet;
	@Input()
	component: AssemblyConfig.Component;

	public boxPlotOptions: Highcharts.Options;
	public plotError: string;

	async ngOnInit() {
		this.boxPlotOptions = undefined;
		this.plotError = undefined;
		try {
			const comparison = await this.api.GetFleetCompare(this.asset.asset_id, this.component.id);
			if (comparison.length === 0) {
				throw new Error("No valid assets to compare");
			}
			this.boxPlotOptions = this.charting.BoxPlotDefaults("HIs", comparison.map(item => item.asset_name), comparison.map(item => item.stats), comparison.map(item => item.outliers), "HI", AssemblyConfig.HumsHiThreshold.Warning, AssemblyConfig.HumsHiThreshold.Alarm);
		} catch (err) {
			this.plotError = DvsUtilities.GetRemoteErrorMessage(err, "Couldn't load fleet comparison");
		}
	}
}
